import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-collect-response',
  templateUrl: './collect-response.component.html',
  styleUrls: ['./collect-response.component.scss']
})
export class CollectResponseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
